module.exports = __webpack_public_path__ + "img/corneal-infiltrates-3.38ac271c.jpg";